module.exports = __webpack_public_path__ + "img/popbk.763ff290.png";